"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var CrudService_1 = __importDefault(require("../Core/CrudService"));
var baseRoute = '/lookup-service';
exports.Routes = {
    GET_USERS: "".concat(baseRoute, "/user"),
    GET_RUNS: "".concat(baseRoute, "/run"),
    GET_TASKS_BY_EXTERNAL_ID: "".concat(baseRoute, "/task/external-id"),
    GET_TASKS_TITLES: "".concat(baseRoute, "/task/title"),
    GET_PLANNED_ROUTES: "".concat(baseRoute, "/planned-route"),
    GET_TEAMS: "".concat(baseRoute, "/team"),
    GET_PARKING_SPOTS: "".concat(baseRoute, "/parking-spot"),
    GET_WAYPOINT_ZIPCODE: "".concat(baseRoute, "/waypoint/zipcode"),
    GET_WAYPOINT_ADDRESS: "".concat(baseRoute, "/waypoint/address"),
    GET_WAYPOINT_NAMES: "".concat(baseRoute, "/waypoint/name"),
    GET_WAYPOINT_PHONE: "".concat(baseRoute, "/waypoint/phone"),
    GET_WAYPOINT_CITY: "".concat(baseRoute, "/waypoint/city"),
    GET_CUSTOMER_NAMES: "".concat(baseRoute, "/customer/name"),
    GET_CUSTOMER_ORIGINAL_PHONES: "".concat(baseRoute, "/customer/original-phone-number")
};
var LookupService = /** @class */ (function () {
    function LookupService(session) {
        this.service = new CrudService_1.default(session, 'lookup');
    }
    LookupService.prototype.getUsers = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_USERS)
                        .withQueryString(query)
                        .setException('Failed to get users from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getRuns = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_RUNS)
                        .withQueryString(query)
                        .setException('Failed to get runs from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getTasksByExternalId = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_TASKS_BY_EXTERNAL_ID)
                        .withQueryString(query)
                        .setException('Failed to get tasks by external id from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getTasksTitles = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_TASKS_TITLES)
                        .withQueryString(query)
                        .setException('Failed to get tasks titles from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getPlannedRoutes = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_PLANNED_ROUTES)
                        .withQueryString(query)
                        .setException('Failed to get planned routes from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getTeams = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_TEAMS)
                        .withQueryString(query)
                        .setException('Failed to get teams from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    // ---- Waypoints
    LookupService.prototype.getWaypointZipcodes = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_WAYPOINT_ZIPCODE)
                        .withQueryString(query)
                        .setException('Failed to get waypoint zipcodes from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getWaypointAddresses = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_WAYPOINT_ADDRESS)
                        .withQueryString(query)
                        .setException('Failed to get waypoint addresses from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getWaypointCities = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_WAYPOINT_CITY)
                        .withQueryString(query)
                        .setException('Failed to get waypoint cities from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getWaypointPhones = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_WAYPOINT_PHONE)
                        .withQueryString(query)
                        .setException('Failed to get waypoint phones from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    // ---- Customer
    LookupService.prototype.getCustomerNames = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_CUSTOMER_NAMES)
                        .withQueryString(query)
                        .setException('Failed to get customer names from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getWaypointNames = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_WAYPOINT_NAMES)
                        .withQueryString(query)
                        .setException('Failed to get waypoint names from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getCustomerOriginalPhones = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_CUSTOMER_ORIGINAL_PHONES)
                        .withQueryString(query)
                        .setException('Failed to get customer original phones from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    LookupService.prototype.getParkingSpots = function (query, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_PARKING_SPOTS)
                        .withQueryString(query)
                        .setException('Failed to get parking spots from lookup service')
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    return LookupService;
}());
exports.default = LookupService;
//# sourceMappingURL=lookup-service.js.map